import React from 'react';
import { useAuth } from '@hiiretail/core';
import { Spinner } from '../Spinner/Spinner';

export const AppContent: React.FC = ({ children }) => {
  const { isInitialized, isFetchingPermissions } = useAuth();
  return (
    <>
      {!isInitialized || isFetchingPermissions ? (
        <Spinner dataTestId="app-content-spinner" />
      ) : (
        children
      )}
    </>
  );
};
